import { render, staticRenderFns } from "./Setup2FA.vue?vue&type=template&id=3de2a324"
import script from "./Setup2FA.vue?vue&type=script&lang=js"
export * from "./Setup2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports